<template>
  <div style="position: relative;">
    <el-form ref="serviceListFilter" :model="serviceList" :size="defaultFormItemSize"
      label-width="100px" label-position="right" @submit.native.prevent
    >
      <filter-box :item-width="350">
        <el-form-item label="服务主题" prop="formFilter.subjectName">
          <el-input class="filter-item" v-model="serviceList.formFilter.subjectName"
            :clearable="true" placeholder=""
          />
        </el-form-item>
        <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="onResetServiceList">重置</el-button>
        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="refreshServiceList(true)">查询</el-button>
        <el-button slot="operator" type="primary" :size="defaultFormItemSize" @click="onServiceFormClick()">
          新增
        </el-button>
      </filter-box>
    </el-form>
    <el-row>
      <el-col :span="24">
        <el-table ref="serviceSubject" :data="serviceList.ServiceSubject.impl.dataList" :size="defaultFormItemSize" @sort-change="serviceList.ServiceSubject.impl.onSortChange"
          header-cell-class-name="table-header-gray"
          highlight-current-row @current-change="serviceList.ServiceSubject.impl.currentRowChange"
        >
          <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="serviceList.ServiceSubject.impl.getTableIndex" />
          <el-table-column label="主题名称" prop="subjectName">
          </el-table-column>
          <el-table-column label="服务类型" prop="serviceTypeDictMap.name">
          </el-table-column>
          <el-table-column label="关键词" prop="keyWords">
          </el-table-column>
          <el-table-column label="创建人" prop="createUserIdDictMap.name">
          </el-table-column>
          <el-table-column label="服务类型" prop="serviceTypeDictMap.name">
          </el-table-column>
          <el-table-column label="服务专家" prop="specialistIdDictMap.name">
          </el-table-column>
          <el-table-column label="操作" fixed="right">
            <template slot-scope="scope">
              <el-button @click.stop="onServicFormEditClick(scope.row)" type="text" :size="defaultFormItemSize"
                :disabled="!checkPermCodeExist('serviceList:serviceList:servicFormEdit')">
                编辑查看
              </el-button>
              <el-button @click.stop="onDeleteClick(scope.row)" type="text" :size="defaultFormItemSize"
                :disabled="!checkPermCodeExist('serviceList:serviceList:delete')">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="end" style="margin-top: 10px;">
          <el-pagination
            :total="serviceList.ServiceSubject.impl.totalCount"
            :current-page="serviceList.ServiceSubject.impl.currentPage"
            :page-size="serviceList.ServiceSubject.impl.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, prev, pager, next, sizes"
            @current-change="serviceList.ServiceSubject.impl.onCurrentPageChange"
            @size-change="serviceList.ServiceSubject.impl.onPageSizeChange">
          </el-pagination>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { ServiceSubjectController, DictionaryController } from '@/api';

export default {
  name: 'serviceList',
  props: {
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin],
  data () {
    return {
      serviceList: {
        formFilter: {
          subjectName: undefined
        },
        formFilterCopy: {
          subjectName: undefined
        },
        ServiceSubject: {
          impl: new TableWidget(this.loadServiceSubjectWidgetData, this.loadServiceSubjectVerify, true, true)
        },
        isInit: false
      }
    }
  },
  methods: {
    onResetServiceList () {
      this.$refs.serviceListFilter.resetFields();
      this.refreshServiceList(true);
    },
    /**
     * 专家服务表数据获取函数，返回Promise
     */
    loadServiceSubjectWidgetData (params) {
      if (params == null) params = {};
      params = {
        ...params,
        serviceSubjectDtoFilter: {
          subjectName: this.serviceList.formFilterCopy.subjectName
        },
        orderParam: [
          {
            fieldName: 'createTime',
            asc: false
          }
        ]
      }
      return new Promise((resolve, reject) => {
        ServiceSubjectController.list(this, params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
          // 恢复当前选择行
          if (this.serviceList.ServiceSubject.impl.currentRow !== null) {
            this.$nextTick(() => {
              let currentRow = findItemFromList(res.data.dataList, this.serviceList.ServiceSubject.impl.currentRow.id, 'id');
              this.$refs.serviceSubject.setCurrentRow(currentRow);
            });
          }
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 专家服务表数据获取检测函数，返回true正常获取数据，返回false停止获取数据
     */
    loadServiceSubjectVerify () {
      this.serviceList.formFilterCopy.subjectName = this.serviceList.formFilter.subjectName;
      return true;
    },
    /**
     * 更新专家服务管理列表
     */
    refreshServiceList (reloadData = false) {
      if (reloadData) {
        this.serviceList.ServiceSubject.impl.refreshTable(true, 1);
      } else {
        this.serviceList.ServiceSubject.impl.refreshTable();
      }
      if (!this.serviceList.isInit) {
        // 初始化下拉数据
      }
      this.serviceList.isInit = true;
    },
    /**
     * 新增
     */
    onServiceFormClick () {
      let params = {};

      params.closeVisible = 1;
      this.$router.push({name: 'serviceAdd', query: params});
    },
    /**
     * 编辑查看
     */
    onServicFormEditClick (row) {
      let params = {
        id: row.id
      };

      params.closeVisible = 1;
      this.$router.push({name: 'servicForm', query: params});
    },
    /**
     * 删除
     */
    onDeleteClick (row) {
      let params = {
        id: row.id
      };

      ServiceSubjectController.delete(this, params).then(res => {
        this.$message.success('删除成功');
        this.serviceList.ServiceSubject.impl.refreshTable(false, 1);
      }).catch(e => {});
    },
    onResume () {
      this.refreshServiceList();
    },
    initFormData () {
    },
    formInit () {
      this.refreshServiceList();
    }
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  },
  watch: {
  }
}
</script>
